import * as LDClient from "launchdarkly-js-client-sdk";
import { Singleton } from 'app/utils';
import { $Constants, $CurrentUser, Company } from 'app/classes';


export class LaunchDarklyService {
    public ldclient: any = null;
    public initalized: boolean = false;
 
    public userFeatures: any = { webChannelDisplay: false, intercomIntegration: false };
    public init(user) {
        // if there is already a LaunchDarkly session going, let's close it
        if (this.ldclient) {
            this.ldclient.close();
          }
        var ldPromise = new Promise((resolve, reject) => {
            if (!user.id) {
                reject({ error: 'no user id' });
            }
            const ldUser = {
                key: user.id,
                firstName: user.name.first,
                lastName: user.name.last,
                email: user.email,
                anonymous: false,
                avatar: user.avatar_image_url,
                bootstrap: {
                    'web-channel-notification': false,
                    'intercom-integration': false
                },
                custom: {
                    organizationId: user.company.id,
                    organizationName: user.company.name,
                    user_type: user.user_type
                }
            };
            try {
                this.ldclient = LDClient.initialize($Constants.launchdarkly, ldUser);
                this.ldclient.on('ready', () => {
                    // this sets the initial feature flags now that update method is gone
                    this.ldclient.identify(ldUser, null, () => {
                        this.userFeatures = {
                            webChannelDisplay: this.ldclient.variation('web-channel-notification', false),
                            intercomIntegration: this.ldclient.variation('intercom-integration', false)
                        };
                        this.initalized = true;
                    });
                });
                this.ldclient.on('change', (settings) => {
                    // LaunchDarkly only sends the feature flag that is updated, so both need to be checked individually
                    if (settings['web-channel-notification']) {
                        this.userFeatures.webChannelDisplay = settings['web-channel-notification'].current || false;
                    }
                    if (settings['intercom-integration']) {
                        this.userFeatures.intercomIntegration = settings['intercom-integration'].current || false;
                    }
                });
                resolve({ ready: true })
            } catch (e) {
                reject({ ready: false, error: e });
            }
        });
        return ldPromise;
    }

    public logoutUser() {
        this.ldclient.close();
    }
}
export let $LaunchDarklyService = Singleton('$LaunchDarklyService', LaunchDarklyService);
